export class ProgressStep{
    icon;
    label;
    
    constructor(icon, label) {
        this.icon = icon;
        this.label = label;
    }
}